import { tns } from 'tiny-slider/src/tiny-slider';

if (document.querySelector(".hero__slider")) {
    let heroSlider = tns({
        container: '.hero__slider',
        items: 1,    
        mouseDrag: true,
        autoplay: true,
        autoplayTimeout: 7500,
        controls: false,
        nav: false,
        lazyload: true,
        autoplayButtonOutput: false,
    });
}

if (document.querySelector(".products__slider")) {
    let productSlider = tns({
        container: '.products__slider',
        responsive: {
            0: {
                items: 1,
                gutter: '10',
                nav: true
            },
            768: {
                items: 2,
                gutter: '20',
                nav: false
            },
            960: {
                items: 3,
            }
        },
        autoplay: true,
        controls: false,
        nav: false,
        autoplayButtonOutput: false,
    });

    let prev = document.querySelector('.products__slider-nav .js-prev');
    let next = document.querySelector('.products__slider-nav .js-next');

    // slider navigation
    prev.addEventListener('click', function () {
        productSlider.goTo('prev');
    });
    next.addEventListener('click', function () {
        productSlider.goTo('next');
    });
}

if (document.querySelector(".brands__slider")) {
    let brandsSlider = tns({
        container: '.brands__slider',
        responsive: {
            0: {
                items: 2,
                gutter: '20'
            },
            768: {
                items: 3,
                gutter: '30'
            },
            960: {
                items: 4,
                gutter: '40'
            }
        },
        autoplay: true,
        mouseDrag: true,
        controls: false,
        autoplayButtonOutput: false,
    });
}
if (document.querySelector(".testimonials__slider")) {
    let testimonialSlider = tns({
        container: '.testimonials__slider',
        items: 1,
        controls: false,
        autoplay: true,
        autoHeight: true,
        mouseDrag: true,
        autoplayButtonOutput: false,
    });
}

// fix om dots navigatie onder de slides te positioneren
const navs = document.querySelectorAll(".tns-nav");
for(let i = 0; i < navs.length; i++) {
    navs[i].parentNode.appendChild(navs[i]);
}
